<template lang="html">
  <div class="question-container">
    <div class="close-icon-div">
      <v-btn flat icon @click = "$emit('close')"><i class="close-icon"></i></v-btn>
      <span class="question-number">{{ `${index+1} / ${totalNumberOfQuestion}` }}</span>
    </div>
    <div class="title--txt">
      <vue-markdown :source = "taskCompletionItem.task_completion_text">{{ taskCompletionItem.task_completion_text }}</vue-markdown>
    </div>
    <div class="welcome-txt">
      <div class="slider-container">
        <input
        type="range"
        step="1"
        :min="this.minMax[0]"
        :max="this.minMax[1]"
        class="slider"
        v-model="value"
        />
      </div>
      <div class="min-max-txt">
        <span class="min-val-txt">Min: {{ this.minMax[0] }}</span>
        <span class="max-val-txt">Max: {{ this.minMax[1] }}</span>
      </div>
      <div class="current-val-txt">
        Selcted value is {{ this.value }}
      </div>
    </div>
    <div class="button-container">
      <v-btn flat small class="edit" @click = "$emit('previous')"><span>Back</span></v-btn>
      <v-btn :disabled="!value" large @click = "$emit('next'); submitTaskCompletionItemValue();" class="next-button">Next</v-btn>
    </div>
  </div>
</template>

<script>
import VueMarkdown from 'vue-markdown';

export default {
  components: {
    VueMarkdown,
  },
  data() {
    return {
      value: null,
      minMax: [],
      totalNumberOfQuestion: null,
    };
  },
  props: {
    index: {
      type: Number,
    },
  },
  computed: {
    taskCompletionItem() {
      const items = this.$store.getters['completionQuestions/taskCompletionList'];
      this.minMax = items[this.index].task_completion_elements.split('|');
      this.totalNumberOfQuestion = items.length;
      return items[this.index] || {};
    },
  },
  methods: {
    submitTaskCompletionItemValue() {
      this.$store.dispatch('completionQuestions/submitTaskCompletionItem', {
        completion_value: this.value,
        task_completion_item_id: this.taskCompletionItem.task_completion_item_id,
      });
      this.defaultState();
    },
    defaultState() {
      this.value = 0;
      this.minMax = [];
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/shared.scss";
@import "~styles/completion_questions.scss";
#app {
  .slider-container {
    width: 100%;
    flex-grow: 1;
  }

  .slider {
    -webkit-appearance: none;
    width: 100%;
    height: 15px;
    border-radius: 5px;
    background: $light;
    outline: none;
    opacity: 0.7;
    -webkit-transition: .2s;
    transition: opacity .2s;
  }

  .slider:hover {
      opacity: 1;
  }

  .slider::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: 25px;
      height: 25px;
      border-radius: 50%;
      background: $blue;
      cursor: pointer;
  }

  .slider::-moz-range-thumb {
      width: 25px;
      height: 25px;
      border-radius: 50%;
      background: $blue;
      cursor: pointer;
  }
  .button-container {
    flex-grow: 2;
  }

  .min-val-txt {
    float: left;
  }
  .max-val-txt {
    float: right;
  }

  .title--txt {
    flex-grow: 5;
  }

  .welcome-txt {
    flex-grow: 12;
    justify-content: space-around;
  }

  .current-val-txt {
    flex-grow: 6;
    font-family: MuseoSans-900;
    font-size: 22px;
  }

  .min-max-txt {
    .min-val-txt {
      font-family: MuseoSans-900;
    }
    .max-val-txt {
      font-family: MuseoSans-900;
    }
    flex-grow: 1;
  }

  @media only screen and (min-width:500px) {
    .button-container {
      text-align: center;
    }
  }
  @media only screen and (max-width:499px) {
    .question-number {
      margin-left: 33%;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/QuestionsTypes/MinMaxQuestion.vue